import * as RadixScrollArea from '@radix-ui/react-scroll-area'
import React from 'react'
import styles from './ScrollArea.module.css'

export function Root({ ref, ...props }: React.ComponentPropsWithRef<typeof RadixScrollArea.Root>) {
  return <RadixScrollArea.Root ref={ref} className={styles.root} {...props} />
}

export function Viewport({ ref, ...props }: React.ComponentPropsWithRef<typeof RadixScrollArea.Viewport>) {
  return <RadixScrollArea.Viewport ref={ref} className={styles.viewport} {...props} />
}

export function Scrollbar({ ref, ...props }: React.ComponentPropsWithRef<typeof RadixScrollArea.Scrollbar>) {
  return <RadixScrollArea.Scrollbar ref={ref} className={styles.scrollbar} {...props} />
}

export function Thumb({ ref, ...props }: React.ComponentPropsWithRef<typeof RadixScrollArea.Thumb>) {
  return <RadixScrollArea.Thumb ref={ref} className={styles.thumb} {...props} />
}
